import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import PermissionsMenu from "../../../routes/app/components/PermissionsMenu";
import { userCanAccessAllTenants, isUserMultiTenant, shouldShowDivision, userHasContractTenancy, userHasRole } from "../../../swzutils/UserPermissionsUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxArchive } from '@fortawesome/free-solid-svg-icons/faBoxArchive';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faGaugeHigh } from '@fortawesome/free-solid-svg-icons/faGaugeHigh';
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMap } from '@fortawesome/free-solid-svg-icons/faMap';
import { faMaximize } from '@fortawesome/free-solid-svg-icons/faMaximize';
import { faNoteSticky } from '@fortawesome/free-solid-svg-icons/faNoteSticky';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../store";
import { loggedInUserSelector, selectedTenantSelector, selectedTenantSettingsSelector } from "../../../store/slice/auth";
const menuItems = (loggedInUser, selectedTenant, selectedTenantSettings) => {
    const isExclusiveFleetAdminUser = loggedInUser
        && userHasRole(loggedInUser, "FLEET_ADMIN")
        && loggedInUser.roles.length === 1;
    return [{
            key: "app/home",
            route: "#/app/home",
            icon: _jsx(FontAwesomeIcon, { icon: faHouse }),
            text: "Home"
        }, {
            key: "app/dashboard",
            permissions: ['admin:dashboard:view'],
            route: "#/app/dashboard",
            icon: _jsx(FontAwesomeIcon, { icon: faGaugeHigh }),
            text: "Dashboard"
        }, {
            key: "app/map/driver",
            permissions: ['admin:driver:location:list'],
            route: "#/app/map/driver",
            icon: _jsx(FontAwesomeIcon, { icon: faMap }),
            text: "Live Map"
        }, {
            key: "app/consignments",
            icon: _jsx(FontAwesomeIcon, { icon: faTags }),
            text: "Delivery",
            subMenu: [{
                    key: "app/consignments/list",
                    permissions: ['admin:consignment:list'],
                    route: "#/app/consignments/list",
                    text: "My Deliveries"
                }, {
                    key: "app/partner-consignments/list",
                    permissions: ['admin:consignmentPartnership:list'],
                    route: "#/app/consignments/partners-list",
                    text: "Partner Deliveries"
                }, {
                    key: "app/consignments/import",
                    permissions: ['admin:consignment:import'],
                    route: "#/app/consignments/import",
                    text: "Delivery Imports"
                }, {
                    key: "app/planning/deliveryStatus",
                    permissions: ['admin:vehicle:deliveryStatus'],
                    route: '#/app/planning/delivery-status',
                    text: 'Delivery Status'
                }, {
                    key: "app/consignments/templates",
                    permissions: ['admin:consignmentTemplate:list'],
                    route: "#/app/consignments/templates",
                    text: "Delivery Favourites"
                }, {
                    key: "app/sendersReceivers/list",
                    permissions: ['admin:senderReceiver:list'],
                    route: "#/app/senders-receivers/list",
                    text: "Saved Locations"
                }, {
                    key: "app/map/service-areas",
                    permissions: ['admin:geographicArea:list'],
                    route: "#/app/map/delivery-areas",
                    text: "Delivery Areas"
                }]
        }, {
            key: "app/salesOrders",
            icon: _jsx(FontAwesomeIcon, { icon: faNoteSticky }),
            text: "Sales",
            subMenu: [{
                    key: "app/salesOrders/list",
                    permissions: ['admin:salesOrder:list'],
                    route: "#/app/sales-orders/list",
                    text: "My Orders"
                }, {
                    key: "app/pickups/list",
                    permissions: ['admin:salesOrder:list'],
                    route: "#/app/pickups/list",
                    text: "Pick ups"
                }, {
                    key: 'app/products/list',
                    permissions: ['admin:product:list'],
                    route: '#/app/products/list',
                    text: 'Products'
                }, {
                    key: "app/customers/list",
                    permissions: ['admin:customer:list'],
                    route: "#/app/customers/list",
                    text: "Customers"
                }, {
                    key: 'app/debtors/list',
                    permissions: ['admin:debtor:list'],
                    route: '#/app/debtors/list',
                    text: 'Debtors'
                }, {
                    key: 'app/pricing/prices',
                    permissions: ['admin:productPrice:list'],
                    route: '#/app/products/prices',
                    text: 'Prices',
                }, {
                    key: 'app/pricing/list',
                    permissions: ['admin:productPriceList:list'],
                    route: '#/app/products/price-lists',
                    text: 'Price Lists'
                }, {
                    key: "app/sales/fees",
                    permissions: ['admin:tenant:feeBase:list'],
                    route: "#/app/tenants/fees/base",
                    text: "Fees",
                }, {
                    key: 'app/consignment/billable/list',
                    permissions: ['admin:consignmentBillable:list'],
                    route: '#/app/consignments/billing',
                    text: 'Billing Approvals'
                }, {
                    key: 'app/debtors/invoices/list',
                    permissions: ['admin:debtor:invoices:list'],
                    route: '#/app/debtors/invoices',
                    text: 'Invoices'
                }]
        }, {
            key: "app/planning",
            icon: _jsx(FontAwesomeIcon, { icon: faMaximize }),
            text: "Planning",
            subMenu: [{
                    key: "app/planning/freight",
                    permissions: ['admin:consignmentFreight:split', 'admin:consignmentFreight:separate'],
                    route: '#/app/planning/freight',
                    text: 'Delivery Pre Plan'
                }, {
                    key: "app/planning/delivery",
                    permissions: ['admin:planning:edit'],
                    route: '#/app/planning/delivery',
                    text: 'Pickup & Delivery'
                }, {
                    key: "app/planning/map",
                    permissions: ['admin:planning:edit'],
                    route: '#/app/planning/map',
                    text: "Pickup & Delivery Map"
                }, {
                    key: "app/planning/hires",
                    permissions: ['admin:salesOrder:hireBookings:list'],
                    route: '#/app/planning/hires',
                    text: 'Vehicle Request'
                }, {
                    key: "app/planning/lineHaul",
                    permissions: ['admin:lineHaul:list'],
                    route: '#/app/planning/line-haul',
                    text: 'Line Haul'
                }, {
                    key: "app/planning/carrier",
                    permissions: ['admin:tenant:partnerships:listCarrierDeliveries'],
                    route: '#/app/planning/carrier',
                    text: 'Carrier'
                }]
        }, {
            key: "app/marketplace",
            icon: _jsx(FontAwesomeIcon, { icon: faUsers }),
            text: "Marketplace",
            subMenu: [{
                    key: "app/marketplace/ondemand",
                    permissions: ['admin:consignmentMarketplace:list'],
                    route: '#/app/planning/marketplace',
                    text: 'On Demand'
                }, {
                    key: "app/vehicleHires/list",
                    permissions: ['admin:vehicleHires:list'],
                    route: "#/app/vehicle-hires/list",
                    text: "Hire Request"
                }, {
                    key: "app/marketplace/products",
                    permissions: ['admin:senderReceiverProductMarketplace:list'],
                    route: "#/app/senders-receivers/marketplace-products",
                    text: "Products"
                }, {
                    key: "app/vehicleHires/templates",
                    permissions: ['admin:vehicleHireTemplate:list'],
                    route: "#/app/vehicle-hires/templates",
                    text: "Hire Favourites"
                }, {
                    key: "app/marketplace/available",
                    permissions: ['admin:consignment:listMarketplace', 'admin:vehicleHires:listMarketplace'],
                    condition: userHasContractTenancy(loggedInUser, selectedTenant) || userCanAccessAllTenants(loggedInUser),
                    route: '#/app/marketplace/available',
                    text: 'Available Jobs'
                }, {
                    key: "app/marketplace/accepted",
                    permissions: ['admin:consignment:listMarketplace', 'admin:vehicleHires:listMarketplace'],
                    condition: userHasContractTenancy(loggedInUser, selectedTenant) || userCanAccessAllTenants(loggedInUser),
                    route: '#/app/marketplace/accepted',
                    text: 'Accepted Jobs'
                }]
        }, {
            key: "app/vehicles",
            icon: _jsx(FontAwesomeIcon, { icon: faTruck }),
            text: "Vehicles",
            condition: !isExclusiveFleetAdminUser,
            subMenu: [{
                    key: "app/vehicles/list",
                    permissions: ['admin:vehicle:create', 'admin:vehicle:update', 'admin:vehicle:view'],
                    route: "#/app/vehicles/list",
                    text: "Setup",
                }, {
                    key: "app/vehicles/out-of-service",
                    permissions: ['admin:vehicleOutOfService:list'],
                    route: "#/app/vehicles/out-of-service",
                    text: "Out of Service"
                }]
        }, {
            key: "app/vehicles/fleet_admin",
            permissions: ['admin:vehicle:list'],
            route: "#/app/vehicles/list",
            icon: _jsx(FontAwesomeIcon, { icon: faTruck }),
            text: "Vehicles",
            condition: isExclusiveFleetAdminUser
        }, {
            key: "app/drivers/fleet_admin",
            permissions: ['admin:driver:list'],
            route: "#/app/drivers/list",
            icon: _jsx(FontAwesomeIcon, { icon: faCircleUser }),
            text: "Drivers",
            condition: isExclusiveFleetAdminUser
        }, {
            key: "app/people",
            icon: _jsx(FontAwesomeIcon, { icon: faCircleUser }),
            text: "Team & Partners",
            permissions: ['admin:user:list', 'admin:driver:list', 'admin:tenant:partnerships:list'],
            condition: !isExclusiveFleetAdminUser,
            subMenu: [{
                    key: "app/people/users/list",
                    permissions: ['admin:user:list'],
                    route: "#/app/users/list",
                    text: "Users"
                }, {
                    key: "app/people/drivers/list",
                    permissions: ['admin:driver:list'],
                    route: "#/app/drivers/list",
                    text: "Drivers"
                }, {
                    key: "app/partners/list",
                    permissions: ['admin:tenant:partnerships:list'],
                    route: "#/app/tenants/partners",
                    text: "Partners"
                }]
        }, {
            key: "app/reusablePackaging",
            route: "#/app/reusablePackaging/list",
            icon: _jsx(FontAwesomeIcon, { icon: faBoxArchive }),
            text: "Reusable Packaging",
            condition: selectedTenantSettings?.reusablePackagingEnabled,
            subMenu: [{
                    key: "app/reusablePackaging/list",
                    permissions: ['admin:reusablePackaging:list'],
                    route: "#/app/reusable-packaging/setup",
                    text: "Setup"
                }, {
                    key: "app/reusablePackaging/accounts",
                    permissions: ['admin:reusablePackagingAccount:list'],
                    route: "#/app/reusable-packaging/balances",
                    text: "Balances"
                }, {
                    key: "app/reusablePackaging/movements",
                    permissions: ['admin:reusablePackagingMovement:list'],
                    route: "#/app/reusable-packaging/movements",
                    text: "Movements"
                }]
        }, {
            key: "app/reports",
            route: "#/app/reports",
            icon: _jsx(FontAwesomeIcon, { icon: faDownload }),
            text: "Reports",
            subMenu: [{
                    key: "app/reports/list",
                    permissions: ['admin:chart:list'],
                    route: "#/app/reports/list",
                    text: "Charts"
                }, {
                    key: "app/reports/csv",
                    permissions: ['admin:reports:list'],
                    route: "#/app/reports/csv",
                    text: "CSV Exports"
                }, {
                    key: "app/reports/drivers/sessions",
                    permissions: ['admin:userSession:history'],
                    route: "#/app/drivers/session-history",
                    text: "Driver Login History"
                }, {
                    key: "app/reports/driverTimeSheet/list",
                    permissions: ['admin:driverTimesheet:list'],
                    route: "#/app/drivers/timesheets",
                    text: "Driver Timesheets"
                }, {
                    key: "app/reports/driverChecklists/list",
                    permissions: ['admin:driverChecklist:list'],
                    route: "#/app/checklists/driver/list",
                    text: "Checklists"
                }, {
                    key: "app/reports/registrations/list",
                    permissions: ['admin:tenant:registrations:list'],
                    route: "#/app/tenants/registrations",
                    text: "Registrations"
                }, {
                    key: 'app/admin/compliance-approvals',
                    permissions: ['admin:complianceApproval:list'],
                    route: '#/app/admin/compliance-approvals/list',
                    text: 'Compliance Approvals'
                }]
        }, {
            key: "app/settings",
            route: "#/app/settings",
            icon: _jsx(FontAwesomeIcon, { icon: faGear }),
            text: "Settings",
            subMenu: [{
                    key: "app/sms-rules/list",
                    permissions: ['admin:smsRule:list'],
                    route: "#/app/sms-rules/list",
                    text: "SMS Rules"
                }, {
                    key: "app/email/suppression/list",
                    permissions: ['admin:emailSuppression:list'],
                    route: '#/app/email/suppression',
                    text: 'Email Suppression'
                }, {
                    key: "app/people/drivers/fatigue/list",
                    permissions: ['admin:fatigueSchedule:list'],
                    route: "#/app/drivers/fatigue/list",
                    text: "Driver Fatigue",
                }, {
                    key: "app/settings/division",
                    condition: shouldShowDivision(loggedInUser, selectedTenant),
                    permissions: ['admin:division:list'],
                    route: '#/app/divisions/list',
                    text: 'Divisions'
                }, {
                    key: "app/settings/profile",
                    permissions: ['admin:tenant:update'],
                    route: '#/app/tenants/edit/{tenantId}',
                    text: 'Profile'
                }, {
                    key: "app/settings/billing",
                    permissions: ['admin:billing:view'],
                    route: '#/app/billing/tenant',
                    text: 'Billing'
                }, {
                    key: "app/tenants/deliveryCredits/list",
                    permissions: ['admin:billing:deliveryCredits:list'],
                    route: "#/app/tenants/credits",
                    text: "Delivery Credits"
                }, {
                    key: "app/tenants/list",
                    condition: isUserMultiTenant(loggedInUser),
                    permissions: ['admin:tenant:update'],
                    route: "#/app/tenants/list",
                    text: "Profiles",
                }, {
                    key: "app/consignments/specialRequirements",
                    permissions: ['admin:specialRequirement:list'],
                    route: '#/app/consignments/special-requirements/list',
                    text: 'Special Requirements'
                }, {
                    key: 'app/features/list',
                    permissions: ['admin:feature:create'],
                    route: '#/app/features/list',
                    text: 'Features',
                }]
        }, {
            key: "app/admin",
            icon: _jsx(FontAwesomeIcon, { icon: faLock }),
            text: "Admin",
            subMenu: [{
                    key: "app/admin/dashboard",
                    permissions: ['admin:platformDashboard:execute'],
                    route: '#/app/admin/dashboard',
                    text: 'Dashboard'
                }, {
                    key: "app/settings/vehicleRates/list",
                    permissions: ['admin:vehicleRate:list'],
                    route: "#/app/vehicle-rates/list",
                    text: "Contractor Rates"
                }, {
                    key: "app/settings/fuelLevy/list",
                    permissions: ['admin:fuelLevy:list'],
                    route: "#/app/fuel-levies/list",
                    text: "Fuel Levy"
                }, {
                    key: "app/settings/vehicleType/list",
                    permissions: ['admin:vehicleType:uiMenu'],
                    route: "#/app/vehicle-types/list",
                    text: "Vehicle Types"
                }, {
                    key: "app/checklists/manage/list",
                    permissions: ['admin:checklist:list'],
                    route: "#/app/checklists/manage/list",
                    text: "Manage Checklists"
                }, {
                    key: "app/tenants/creditPackages/list",
                    permissions: ['admin:billing:creditPackage:list'],
                    route: "#/app/tenants/credit-packages",
                    text: "Credit Packages"
                }, {
                    key: "app/tenants/marketplaceTransactions/list",
                    permissions: ['admin:billing:marketplaceTransactions:list'],
                    route: "#/app/billing/marketplace",
                    text: "Marketplace Txns"
                }, {
                    key: "app/admin/offers/list",
                    permissions: ['admin:offers:list'],
                    route: '#/app/admin/offers/list',
                    text: 'Offers'
                }, {
                    key: 'app/admin/settings/global/list',
                    permissions: ['subtruxTechSupport:settingsRaw:list'],
                    route: '#/app/admin/settings/list',
                    text: 'Settings'
                }, {
                    key: 'app/admin/scheduled-tasks',
                    permissions: ['subtruxTechSupport:scheduledTasks:list'],
                    route: '#/app/admin/scheduled-tasks',
                    text: 'Scheduled Tasks'
                }, {
                    key: 'app/admin/password-rate-limits',
                    permissions: ['subtruxTechSupport:rateLimits:list'],
                    route: '#/app/admin/password-rate-limits',
                    text: 'Password Rate Limits'
                }]
        }];
};
const AppMenu = (props) => {
    const location = useLocation();
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenantSettings = useAppSelector(selectedTenantSettingsSelector);
    const mode = /* collapsedNav ? 'vertical' : */ 'inline';
    const menuTheme = 'dark'; // 'light';
    const currentPathname = location.pathname;
    return (_jsx("div", { children: _jsx(PermissionsMenu, { menuItems: menuItems(loggedInUser, selectedTenant, selectedTenantSettings), theme: menuTheme, mode: mode, inlineIndent: 10, defaultSelectedKeys: [currentPathname], defaultOpenKeys: ['app/planning/delivery'], onMenuItemSelected: props.onMenuItemSelected }) }));
};
export default AppMenu;
